import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';

interface IPageAL2013 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Al2013Controller(Formulaire: IFormulaireClass, FormulaireItem: IFormulaireItemClass) {
    const vm: IPageAL2013 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            importation: false,
            exportation: false
        },
        colonnesVisibles: [
            { nom: 'upatit', largeur: 150 },
            { nom: 'vacalityp_cod', largeur: 150 },
            { nom: 'vacalityp_desc', largeur: 280 },
            { nom: 'vaeupaseq_desc', largeur: 200 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('upatit', { largeur: 25 }),
            new FormulaireItem('vacalityp', { largeur: 50 }),
            new FormulaireItem('vaeupaseq', { largeur: 10 })
        ])
    };
}
